<template>
  <div
    id="multiple-choice-form"
    class="pb-3"
    v-if="question && question.is_enabled"
  >
    <b-form-group v-if="content && content.visible">
      <template slot="label">
        <div class="d-flex flex-column">
          <div class="question-title mb-2">
            {{ question.question }}
            <sup class="text-danger font-weight-bold" v-if="content.required">
              *
            </sup>
          </div>
          <div>
             <ImageRender
                v-if="question.image"
                :imgBase64="question.image" :showCloseButton="false"/>
          </div>
        </div>
      </template>
      <b-container>
        <b-row>
          <b-form-radio
            v-for="(option, key) in content.attributes.options"
            v-model="selected"
            :key="key"
            :value="option.answer? option.answer : findImageAnswer(key)"
            class="mb-2 text-break"
            :class="content.attributes.width === 'full' ? 'col-12' : 'col-6'"
          >
            <div class="d-flex flex-column">
              <div>{{ option.answer }}</div>
              <ImageRender
                v-if="findImageAnswer(key)"
                :imgBase64="findImageAnswer(key)" :showCloseButton="false"/>
            </div>
          </b-form-radio>
          <b-form-invalid-feedback :state="isInvalid(question.question)">
            {{ errorMessage(question.question) }}
          </b-form-invalid-feedback>
        </b-row>
      </b-container>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";

export default {
  name: "MultipleChoice",
  components: {
    ImageRender,
  },
  data() {
    return {
      content: null,
      selected: "",
    };
  },
  props: ["question", "answers"],
  methods: {
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    findImageAnswer(key) {
      const imageData = this.content.attributes.images.find(item => item.key === key)
      return imageData?.image;
    },
  },
  computed: {
    ...mapGetters("survey", ["errors"]),
  },
  watch: {
    selected() {
      if (this.selected) this.answers[this.question.question] = this.selected;
    },
    question() {
      if (this.question.contents.length) {
        this.content = this.question.contents[0];
      }

      if (this.answers[this.question.question] !== undefined)
        this.selected = this.answers[this.question.question];
      else this.answers[this.question.question] = "";
    }
  },
  created() {
    if (this.question.contents.length) {
      this.content = this.question.contents[0];
    }

    if (this.answers[this.question.question] !== undefined)
      this.selected = this.answers[this.question.question];
    else this.answers[this.question.question] = "";
  },
};
</script>

<style>
</style>